import { API_BASE } from "./endpoint";

export interface SMSChallenge {
  dialingCode: string;
  cellPhone: string;
}

export interface ChallengeVerification {
  challengeId: number;
  code: string;
}

export interface ChallengeResponse {
  succeeded: boolean;
  message?: string;
  challengeId: number;
  method: "sms" | "email";
}

export interface VerificationResponse {
  succeeded: boolean;
  expiresAt: number;
  message?: string;
}

export async function createSMSChallenge(
  dialingCode: string,
  cellPhone: string
): Promise<ChallengeResponse> {
  const challenge: SMSChallenge = { dialingCode, cellPhone };

  const res = await fetch(`${API_BASE}/sign-on/challenge/sms`, {
    method: "POST",
    body: JSON.stringify(challenge),
    headers: { "Content-Type": "application/json" },
  });

  if (!res.ok) {
    return {
      succeeded: false,
      message: "Server error: " + res.status,
      challengeId: -1,
      method: "sms",
    };
  }

  const response: ChallengeResponse = await res.json();

  return response;
}

export async function verifyChallenge(
  challengeId: number,
  code: string
): Promise<VerificationResponse> {
  const verification: ChallengeVerification = { challengeId, code };

  const res = await fetch(`${API_BASE}/sign-on/verify`, {
    method: "POST",
    body: JSON.stringify(verification),
    headers: { "Content-Type": "application/json" },
  });

  if (!res.ok) {
    return {
      succeeded: false,
      message: "Server error: " + res.status,
      expiresAt: 0,
    };
  }

  const response: VerificationResponse = await res.json();

  return response;
}

export async function invalidateSignOn(): Promise<boolean> {
  const res = await fetch(`${API_BASE}/sign-on/invalidate`);

  return res.ok;
}
